// extracted by mini-css-extract-plugin
export default {"pagination-wrapper":"center-pagination_pagination-wrapper__giizh"};